import React, { useState } from 'react';
import MultiSelectPill from '../Common/Filters/MultiSelectPill';
import SiteDto from '../Common/dtos/SiteDto';

const unassignedValue = '__unassigned';

export interface EmployeeSiteFilter {
  values: string[];
  siteIds?: string[];
  includeUnassigned?: boolean;
  setValues: (values: string[]) => void;
}

export const useEmployeeSiteFilter = (sites: SiteDto[]): EmployeeSiteFilter => {
  const [chosen, setValues] = useState<string[]>();

  return {
    values: chosen ?? [...sites.map(site => site.id), unassignedValue],
    siteIds: chosen && chosen.filter(value => value !== unassignedValue),
    includeUnassigned: chosen && chosen.includes(unassignedValue),
    setValues,
  };
};

export const EmployeeSiteFilterPill = ({ sites, filter, debounceMs }: {
  sites: SiteDto[];
  filter: EmployeeSiteFilter;
  debounceMs?: number;
}) => {
  if (sites.length === 0) return null;

  return <MultiSelectPill
    id="employee-order-sites"
    label="Sites"
    icon="geo-alt-fill"
    allLabel="All sites"
    emptyLabel="No sites"
    values={filter.values}
    options={sites.map(site => ({ value: site.id, label: site.name }))}
    extraOption={{ value: unassignedValue, label: 'Unassigned' }}
    debounceMs={debounceMs}
    onChange={filter.setValues} />;
};
